import { useMemo } from 'react';
import { getFeatures } from '../utils/plans';

export const useFeature = (
  selectedFeature,
  features,
) => useMemo(() => getFeatures(selectedFeature, features), [selectedFeature, features]);
